import { notificationsStore } from "../stores";

export const useNotificationsStore = () => notificationsStore;
